function onSelect(ev) {
    ev.preventDefault();

    hideMessage();

    const form = document.getElementById('pm-wall-size-form');
    const rows = parseInt(form.elements['rows'].value, 10);
    const cols = parseInt(form.elements['cols'].value, 10);

    if (rows && cols) {
        showMainSpinner();
        const uuid = getUuid();
        const apiUrl = window.PM_CONFIG.apiUrl + '/pixel-bricks-wall-size/' + uuid;
        postPixelBricksWallSize(apiUrl, rows, cols,
            function(response){
                hideMainSpinner();
                setUuid(response.uuid);
                window.location.href = '/upload-pixel-bricks-wall';
            },
            function(jqXHR, textStatus, errorThrown) {
                console.log(textStatus + '-' + errorThrown);
                hideMainSpinner();
                clearUuid();
                if (jqXHR.responseJSON && jqXHR.responseJSON.error) {
                    showError(jqXHR.responseJSON.error);
                }
                else {
                    showError("pbw.posting_dimensions_error");
                }
            }
        );
    }
}

window.addEventListener('DOMContentLoaded', function() {
    const plateSizeMm = 400;
    const maxPlatesPerSide = 10;
    const millimetersPerInch = 25.4;
    const plateImageSrc = 'assets/images/content/pb-plate.webp';
    const form = document.getElementById('pm-wall-size-form');
    const heightInput = document.getElementById('pm-wall-height-mm');
    const widthInput = document.getElementById('pm-wall-width-mm');
    const unitInput = document.getElementById('pm-wall-unit');
    const unitLabels = document.querySelectorAll('.pm-wall-unit-label');
    const preview = document.getElementById('pm-wall-preview');
    const previewMessage = document.getElementById('pm-wall-preview-message');
    const rowsInput = document.getElementById('pm-wall-rows');
    const colsInput = document.getElementById('pm-wall-cols');
    const wallBtns = document.querySelector('.pm-wall-btns');
    let currentUnit = unitInput.value;

    function formatInchesFromMm(valueMm) {
        return (valueMm / millimetersPerInch).toFixed(2);
    }

    function formatDimensionInCurrentUnit(valueMm) {
        if (currentUnit === 'in') {
            return `${formatInchesFromMm(valueMm)} inches`;
        }

        return `${valueMm} mm`;
    }

    function getPlateSizeLabel() {
        return formatDimensionInCurrentUnit(plateSizeMm);
    }

    function getPlateSizeSquareLabel() {
        const size = formatDimensionInCurrentUnit(plateSizeMm);
        return `${size} x ${size}`;
    }

    function getEmptyPreviewMessage() {
        const size = formatDimensionInCurrentUnit(plateSizeMm);
        return translate('pbw.start_preview_empty', [size, size]);
    }

    function getMinimumPreviewMessage() {
        return translate('pbw.start_preview_min_size', formatDimensionInCurrentUnit(plateSizeMm));
    }

    function getMaxSizeMessage() {
        const maxDim = formatDimensionInCurrentUnit(maxPlatesPerSide * plateSizeMm);
        return translate('pbw.start_preview_max_size', [maxDim, maxDim]);
    }

    function formatCoveredDimensions(heightMm, widthMm) {
        return `${formatDimensionInCurrentUnit(heightMm)} × ${formatDimensionInCurrentUnit(widthMm)}`;
    }

    function valueToMillimeters(value, unit) {
        return unit === 'in' ? value * millimetersPerInch : value;
    }

    function millimetersToUnit(valueMm, unit) {
        return unit === 'in' ? valueMm / millimetersPerInch : valueMm;
    }

    function formatInputValue(value, unit) {
        if (unit === 'in') {
            return value.toFixed(2);
        }

        return String(Math.round(value));
    }

    function getDimensionInMillimeters(input) {
        const numericValue = Number(input.value);

        if (!Number.isFinite(numericValue)) {
            return NaN;
        }

        return valueToMillimeters(numericValue, currentUnit);
    }

    function updateUnitUi() {
        const isInches = currentUnit === 'in';
        const unitSuffix = isInches ? '(' + translate('pbw.start_unit_in') + ')' : '(mm)';

        unitLabels.forEach(function(label) {
            label.textContent = unitSuffix;
        });

        heightInput.step = isInches ? '0.01' : '1';
        widthInput.step = isInches ? '0.01' : '1';
        heightInput.inputMode = isInches ? 'decimal' : 'numeric';
        widthInput.inputMode = isInches ? 'decimal' : 'numeric';
        heightInput.placeholder = isInches ? 'e.g. 78.74' : 'e.g. 2000';
        widthInput.placeholder = isInches ? 'e.g. 62.99' : 'e.g. 1600';
    }

    function convertInputValues(nextUnit) {
        if (nextUnit === currentUnit) {
            return;
        }

        [heightInput, widthInput].forEach(function(input) {
            const numericValue = Number(input.value);

            if (!Number.isFinite(numericValue) || input.value === '') {
                return;
            }

            const valueMm = valueToMillimeters(numericValue, currentUnit);
            input.value = formatInputValue(millimetersToUnit(valueMm, nextUnit), nextUnit);
        });

        currentUnit = nextUnit;
        updateUnitUi();
        renderWallPreview();
    }

    function getPlateCount(valueMm) {
        if (!Number.isFinite(valueMm) || valueMm < plateSizeMm) {
            return 0;
        }

        return Math.floor(valueMm / plateSizeMm);
    }

    function clearPreview() {
        preview.innerHTML = '';
        preview.classList.add('visually-hidden');
        preview.style.removeProperty('grid-template-columns');
    }

    function renderWallPreview() {
        const hasHeight = heightInput.value !== '';
        const hasWidth = widthInput.value !== '';
        const rawRows = getPlateCount(getDimensionInMillimeters(heightInput));
        const rawColumns = getPlateCount(getDimensionInMillimeters(widthInput));
        const rows = Math.min(rawRows, maxPlatesPerSide);
        const columns = Math.min(rawColumns, maxPlatesPerSide);
        const exceedsMax = rawRows > maxPlatesPerSide || rawColumns > maxPlatesPerSide;
        rowsInput.value = rows;
        colsInput.value = columns;

        clearPreview();

        if (!hasHeight || !hasWidth) {
            //previewMessage.textContent = getEmptyPreviewMessage();
            wallBtns.classList.add('visually-hidden');
            return;
        }

        if (rows === 0 || columns === 0) {
            previewMessage.textContent = getMinimumPreviewMessage();
            wallBtns.classList.add('visually-hidden');
            return;
        }

        wallBtns.classList.remove('visually-hidden');

        const fragment = document.createDocumentFragment();
        const totalPlates = rows * columns;

        for (let plateIndex = 0; plateIndex < totalPlates; plateIndex += 1) {
            const plateImage = document.createElement('img');

            plateImage.src = plateImageSrc;
            plateImage.alt = `${getPlateSizeSquareLabel()} Pixelbrick plate`;
            plateImage.loading = 'lazy';
            fragment.appendChild(plateImage);
        }

        preview.style.gridTemplateColumns = `repeat(${columns}, auto)`;
        preview.appendChild(fragment);
        preview.classList.remove('visually-hidden');

        if (exceedsMax) {
            previewMessage.textContent = getMaxSizeMessage();
            return;
        }

        const rowLabel = translate(rows === 1 ? 'pbw.start_preview_row' : 'pbw.start_preview_rows');
        const colLabel = translate(columns === 1 ? 'pbw.start_preview_column' : 'pbw.start_preview_columns');
        const heightDim = formatDimensionInCurrentUnit(rows * plateSizeMm);
        const widthDim = formatDimensionInCurrentUnit(columns * plateSizeMm);
        previewMessage.textContent = translate('pbw.start_preview_result', [rows, rowLabel, columns, colLabel, heightDim, widthDim]);
    }

    heightInput.addEventListener('input', renderWallPreview);
    widthInput.addEventListener('input', renderWallPreview);
    unitInput.addEventListener('change', function() {
        convertInputValues(unitInput.value === 'in' ? 'in' : 'mm');
    });
    form.addEventListener('submit', function(ev) {
        ev.preventDefault();
        renderWallPreview();
    });

    updateUnitUi();
    renderWallPreview();
});
